export default __webpack_public_path__ + "static/media/exploded-view_sprite.f0df5e8e.png";